import React from "react"
import moment from "moment"
import { 
  fillingZeroUtility,
  formatCurrency,
  getFrequencyType,
  getUpfrontPaymentAndCurrency,
  renderLoanCollateral,
  statusColorStyle,
} from "../../lib/utils"
import { Link } from "react-router"
import { Table } from "react-bootstrap"
import FontAwesome from "react-fontawesome"
import ImeiList from "./ImeiList"
import RenderFinancierBatch from "./RenderFinancierBatch"

export default function LoanDetailSummary({ loan, actualDisbursementDate, expectedMaturityDate,
  isAdmin, isAccountant, canEditDevice, reloadLoan }) {

  const { isBusiness, clientId, status, amount, clientName, clientPhoneNumber, createdOn, createdBy,
    id: loanId, financierBatch, affiliationId, isDefaulted,
    bundle: { currencyCode, loanTermFrequency, loanTermFrequencyType, numberOfRepayments,
    repaymentEvery, repaymentFrequencyType, upfrontPayment, loanCollateral, description: bundleDesc }} = loan,

  clientDetailLink = `${ isBusiness ?  '/businesses' : '/customers'}/${ clientId }/detail`

  return (
    <Table responsive striped bordered condensed hover>

      <thead>
        <tr>
          <th colSpan="2" className="align-center">Loan details</th>
        </tr>
      </thead>

      <tbody>
        <tr>
          <td className="col1 strong">Status</td>
          <td className="col2">
            { isDefaulted
              ? <span className="red px-5 rounded-10 border-1 border-red" title="Defaulted loan">Defaulted</span>
              : <span style={{ color: statusColorStyle(status) }}>{ status }</span>
            }
          </td>
        </tr>

        <tr>
          <td className="col1 strong">Principal</td>
          <td className="col2">{ formatCurrency(amount) } { currencyCode }</td>
        </tr>

        <tr>
          <td className="col1 strong">Loan term</td>
          <td className="col2">
            { fillingZeroUtility(loanTermFrequency) }&nbsp;
            { getFrequencyType(loanTermFrequencyType) }
          </td>
        </tr>

        <tr>
          <td className="col1 strong">Nb of repayments</td>
          <td className="col2">
            { fillingZeroUtility(numberOfRepayments) } every&nbsp;
            { fillingZeroUtility(repaymentEvery) }&nbsp;
            { getFrequencyType(repaymentFrequencyType) }
          </td>
        </tr>

        <tr>
          <td className="col1 strong">Disbursement</td>
          <td className="col2">{ actualDisbursementDate }</td>
        </tr>

        <tr>
          <td className="col1 strong">Maturity date</td>
          <td className="col2">{ expectedMaturityDate }</td>
        </tr>

        <tr>
          <td className="col1 strong">Upfront payment ({ upfrontPayment }%)</td>
          <td className="col2">
          { getUpfrontPaymentAndCurrency(amount, upfrontPayment, currencyCode) }
          </td>
        </tr>

        <tr>
          <td className="col1 strong v-center">{ isBusiness ? 'Business' : 'Customer' }</td>
          <td className="col2">
            <Link to={ clientDetailLink }>
              { clientName }
            </Link>&nbsp; &nbsp;
            <small className="gray"><FontAwesome name='phone'/> { clientPhoneNumber }</small>
          </td>
        </tr>

        <tr>
          <td className="col1 strong">Loan collateral</td>
          <td className="col2">{ renderLoanCollateral(loanCollateral) }</td>
        </tr>

        <ImeiList loan={ loan } canEditDevice={ canEditDevice } />

        { (isAdmin || isAccountant) &&
        <tr>
          <td className="col1 strong">Financier batch</td>
          <td>
            <RenderFinancierBatch loanId={ loanId } batch={ financierBatch }
              reloadLoan={ reloadLoan } affiliationId={ affiliationId }
            />
          </td>
        </tr>
        }

        <tr>
          <td className="col1 strong v-center">Description</td>
          <td className="col2">
            <p className="description">{ bundleDesc }</p>
          </td>
        </tr>

        <tr>
          <td className="col1 strong v-center">Submitted by</td>
          <td className="col2">
          { isAdmin
            ? <Link to={`/users/${ createdBy.id }/edit`}>
                { createdBy.name }
              </Link>
            : <span>{ createdBy.name }</span>
          }
          </td>
        </tr>

        <tr className="gray">
          <td className="col1">Created on</td>
          <td className="col2">{ createdOn ? moment(createdOn).format('lll') : '' }</td>
        </tr>

        <tr className="gray">
          <td className="col1">#Ref</td>
          <td className="col2"><small>{ loanId }</small></td>
        </tr>

      </tbody>
    </Table>
  )
}



// WEBPACK FOOTER //
// ./src/components/Loans/LoanDetailSummary.js